var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertLevel2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132.29 132.29",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alertLevel2_svg__a",
    x1: 557.26,
    x2: 557.26,
    y1: 101.3,
    y2: 26.994,
    gradientTransform: "translate(-851.92 -40.412) scale(1.6475)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3723a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f26422",
    offset: 0.068
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f69223",
    offset: 0.939
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8a976",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "alertLevel2_svg__b",
    x1: 571.31,
    x2: 546.36,
    y1: 95.628,
    y2: 36.853,
    gradientTransform: "matrix(1.6475 0 0 1.4339 -851.93 -26.598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fddec8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fddec8",
    offset: 0.068
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fddec8",
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.595
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.939
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8a976",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.35 66.146a61.205 61.205 0 01-61.205 61.205A61.205 61.205 0 014.94 66.146 61.205 61.205 0 0166.145 4.941a61.205 61.205 0 0161.205 61.205z",
    fill: "url(#alertLevel2_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.838 54.649h76.616v22.994H27.838z",
    fill: "url(#alertLevel2_svg__b)"
  }))));
}
export default SvgAlertLevel2;